import {Breakpoints, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiContainer = ({templates, palette}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => ({
  MuiContainer: {
    styleOverrides: {
      root: {
        '& .box': {
          minHeight: '60vh',
          background: palette.tint.info2,
          borderRadius: templates.chonktainer.desktop.border.radius.all,
          [mediaQueries.down('md')]: {
            borderRadius: templates.chonktainer.mobile.border.radius.all
          }
        }
      }
    }
  }
});
